/* Kaimana collection shopping. No product-page or third-party app settings are modified. */
(() => {
  if (window.ksCardShoppingLoaded) return;
  window.ksCardShoppingLoaded = true;
  const cache = new Map();
  const root = window.Shopify?.routes?.root || '/';
  async function product(url, fresh = false) {
    const path = new URL(url, location.origin).pathname;
    if (fresh || !cache.has(path)) cache.set(path, fetch(`${path}.js`).then(r => {
      if (!r.ok) throw new Error('Unable to load sizes. Please open the product details.');
      return r.json();
    }).catch(e => { cache.delete(path); throw e; }));
    return cache.get(path);
  }
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'CAD'}).format(cents / 100);
  function cardVariant(card, p, variant) {
    if (!variant) return;
    card.classList.remove('ks-touch-preview');
    card.querySelectorAll('.card__heading a, [data-ks-open]').forEach(a => {
      const u = new URL(a.href); u.searchParams.set('variant', variant.id); a.href = u.href;
    });
    const img = card.querySelector('.card__media .media > img');
    if (img && variant.featured_image?.src) {
      img.src = variant.featured_image.src; img.removeAttribute('srcset');
      // Never preview the opposite colour after a swatch change.
      const second = img.nextElementSibling;
      const index = p.images.findIndex(src => src.split('?')[0] === variant.featured_image.src.split('?')[0]);
      if (second?.tagName === 'IMG') {
        const next = p.images[index + 1];
        const anotherColour = p.variants.some(v => v.featured_image?.src?.split('?')[0] === next?.split('?')[0] && v.options[Number(card.dataset.colourIndex)] !== card.dataset.colour);
        second.src = next && index >= 0 && !anotherColour ? next : img.src;
        second.removeAttribute('srcset');
      }
    }
    card.querySelectorAll('.price-item--regular').forEach(n => { n.textContent = money(variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price); });
    card.querySelectorAll('.price-item--sale').forEach(n => { n.textContent = money(variant.price); });
    card.querySelector('.price')?.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
  }
  let inlinePanel, inlineTrigger, inlineBusy = false;
  function closeInline(focus = false) {
    if (inlineBusy) return;
    inlinePanel?.remove();
    if (inlineTrigger) {
      inlineTrigger.setAttribute('aria-expanded', 'false');
      if (focus) inlineTrigger.focus();
    }
    inlinePanel = inlineTrigger = null;
  }
  async function quickAdd(trigger) {
    if (inlineBusy || trigger.dataset.loading) return;
    if (inlineTrigger === trigger) { closeInline(true); return; }
    closeInline();
    const card = trigger.closest('.ks-shopping-card');
    trigger.dataset.loading = 'true';
    trigger.setAttribute('aria-busy', 'true');
    const panel = el('div', 'ks-inline-sizes');
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Choose a size to add to bag');
    const status = el('p', 'ks-inline-status', 'Loading sizes…');
    status.setAttribute('role', 'status');
    panel.append(status);
    (card.querySelector('.card__inner') || card).append(panel);
    inlinePanel = panel; inlineTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    try {
      const p = await product(trigger.dataset.productUrl, true);
      if (inlinePanel !== panel) return;
      const options = p.options.map(o => typeof o === 'string' ? {name:o, values:[]} : o);
      const sizeIndex = options.findIndex(o => /^size$/i.test(o.name));
      const colourIndex = options.findIndex(o => /^(color|colour)$/i.test(o.name));
      const colour = card.dataset.colour || card.querySelector('[data-ks-colour][aria-pressed="true"]')?.dataset.ksColour;
      const chosen = options.map((o,i) => i === colourIndex && colour ? colour : o.values.length === 1 ? o.values[0] : null);
      // Only offer one-tap adding when size is the sole outstanding choice.
      if (sizeIndex < 0 || chosen.some((value,i) => i !== sizeIndex && value === null) || !options[sizeIndex].values.length) {
        closeInline(); open(trigger); return;
      }
      panel.replaceChildren();
      panel.append(el('p', 'ks-inline-label', 'Tap size to add'));
      const row = el('div', 'ks-inline-grid'); panel.append(row);
      status.textContent = ''; panel.append(status);
      options[sizeIndex].values.forEach(size => {
        const v = p.variants.find(v => v.options.every((value,i) => value === (i === sizeIndex ? size : chosen[i])));
        const button = el('button', 'ks-inline-size', size); button.type = 'button';
        button.disabled = !v?.available;
        button.setAttribute('aria-label', `${size}${v?.available ? ' — add to bag' : ' — sold out'}`);
        row.append(button);
        button.onclick = async () => {
          if (inlineBusy || !v?.available) return;
          inlineBusy = true; panel.setAttribute('aria-busy', 'true');
          const enabled = [...row.children].filter(b => !b.disabled);
          enabled.forEach(b => { b.disabled = true; });
          status.textContent = `Adding ${size}…`;
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData(); body.append('id', String(v.id)); body.append('quantity', '1');
          if (cart?.getSectionsToRender) {
            body.append('sections', cart.getSectionsToRender().map(s => s.id).join(','));
            body.append('sections_url', location.pathname); cart.setActiveElement?.(trigger);
          }
          let added = false;
          try {
            const res = await fetch(`${root}cart/add.js`, {method:'POST', headers:{'X-Requested-With':'XMLHttpRequest', Accept:'application/json'}, body});
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || 'Unable to add this size. Please try again.');
            added = true;
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'ks-quick-add', productVariantId:String(v.id), cartData:data});
            inlineBusy = false; closeInline(true);
            if (cart?.renderContents && data.sections) { cart.classList.remove('is-empty'); cart.renderContents(data); }
            else location.assign(window.routes?.cart_url || `${root}cart`);
          } catch (error) {
            if (added) location.assign(window.routes?.cart_url || `${root}cart`);
            else status.textContent = error.message;
          } finally {
            inlineBusy = false; panel.removeAttribute('aria-busy'); enabled.forEach(b => { b.disabled = false; });
          }
        };
      });
      const details = el('a', 'ks-inline-details', 'Size guide & details'); details.href = trigger.href; panel.append(details);
      row.querySelector('button:not(:disabled)')?.focus({preventScroll:true});
    } catch (error) { if (inlinePanel === panel) status.textContent = error.message; }
    finally { delete trigger.dataset.loading; trigger.removeAttribute('aria-busy'); }
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeInline(true); });
  document.addEventListener('click', e => {
    if (inlinePanel && !inlinePanel.contains(e.target) && !inlineTrigger.contains(e.target)) closeInline();
  });
  let dialog;
  async function open(trigger) {
    if (dialog?.open) return;
    const card = trigger.closest('.ks-shopping-card');
    const activeSwatch=card.querySelector('[data-ks-colour][aria-pressed="true"]');
    if(activeSwatch&&!card.dataset.colour){card.dataset.colour=activeSwatch.dataset.ksColour;card.dataset.colourIndex=activeSwatch.dataset.optionIndex;}
    dialog = el('dialog','ks-shop-dialog');
    dialog.setAttribute('aria-label','Choose your size');
    const close = el('button','ks-shop-close','×'); close.type='button';close.setAttribute('aria-label','Close quick add');
    const title = el('h2','',card.querySelector('.card__heading')?.textContent.trim() || 'Quick add');
    const status = el('p','ks-shop-status','Loading sizes…');status.setAttribute('role','status');
    const details=el('a','ks-shop-details','View full product details');details.href=trigger.href;
    dialog.append(close,title,status,details);document.body.append(dialog);
    const currentDialog = dialog;
    const previousOverflow=document.body.style.overflow;
    dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;currentDialog.remove();trigger.focus();});
    close.onclick=()=>dialog.close();
    dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
    dialog.showModal();document.body.style.overflow='hidden';
    try {
      const p=await product(trigger.dataset.productUrl,true);
      if(!currentDialog.open)return;
      status.textContent='';
      const options=p.options.map(o=>typeof o==='string'?{name:o,values:[]}:o);
      const chosen=options.map((o,i)=>card.dataset.colourIndex===String(i)?card.dataset.colour:(o.values.length===1?o.values[0]:null));
      const price=el('p','ks-shop-price',money(p.price));title.after(price);
      const form=el('form');form.method='post';form.action=window.routes?.cart_add_url || `${root}cart/add`;
      const id=el('input');id.type='hidden';id.name='id';form.append(id);
      const quantity=el('input');quantity.type='hidden';quantity.name='quantity';quantity.value='1';form.append(quantity);
      const groups=[];
      options.forEach((o,i)=>{
        if(p.has_only_default_variant || (options.length===1&&o.name==='Title'&&o.values[0]==='Default Title')){chosen[i]=o.values[0];return;}
        const group=el('fieldset');group.append(el('legend','',o.name));const row=el('div','ks-shop-values');group.append(row);
        o.values.forEach(value=>{const b=el('button','ks-shop-choice',value);b.type='button';b.dataset.value=value;b.onclick=()=>{chosen[i]=value;status.textContent='';update();};row.append(b);});
        groups.push({i,row});form.append(group);
      });
      const submit=el('button','ks-shop-submit','SELECT OPTIONS');submit.type='submit';form.append(submit);status.before(form);
      let busy=false;
      const variant=()=>p.variants.find(v=>v.options.every((value,i)=>value===chosen[i]));
      function update(){
        groups.forEach(({i,row})=>Array.from(row.children).forEach(b=>{
          b.setAttribute('aria-pressed',String(chosen[i]===b.dataset.value));
          // Earlier choices constrain later rows; first rows stay switchable.
          b.disabled=busy||!p.variants.some(v=>v.available&&v.options[i]===b.dataset.value&&v.options.every((value,j)=>j>=i||!chosen[j]||chosen[j]===value));
        }));
        const v=variant();id.value=v?.id||'';submit.disabled=busy||!v?.available;
        submit.textContent=busy?'ADDING…':v?(v.available?(/\bset\b/i.test(p.title)?'ADD SET TO BAG':'ADD TO BAG'):'SOLD OUT'):'SELECT OPTIONS';
        if(v){price.textContent=money(v.price);details.href=`${trigger.dataset.productUrl.split('?')[0]}?variant=${v.id}`;}
      }
      update();
      form.addEventListener('submit',async e=>{
        e.preventDefault();if(busy||!variant()?.available)return;
        busy=true;update();status.textContent='';
        const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
        const body=new FormData(form);
        if(cart?.getSectionsToRender){body.append('sections',cart.getSectionsToRender().map(s=>s.id).join(','));body.append('sections_url',location.pathname);cart.setActiveElement?.(trigger);}
        let added=false;
        try{
          const res=await fetch(window.routes?.cart_add_url||`${root}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'},body});
          const data=await res.json();if(!res.ok||data.status)throw new Error(data.description||'Unable to add this selection. Please try again.');
          added=true;
          if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'ks-quick-add',productVariantId:id.value,cartData:data});
          currentDialog.close();
          if(cart?.renderContents&&data.sections){cart.classList.remove('is-empty');cart.renderContents(data);}else{location.assign(window.routes?.cart_url||`${root}cart`);}
        }catch(error){
          if(added){location.assign(window.routes?.cart_url||`${root}cart`);return;}
          status.textContent=error.message;
        }finally{busy=false;if(currentDialog.open)update();}
      });
    }catch(error){if(currentDialog.open)status.textContent=error.message;}
  }
  document.addEventListener('click',async e=>{
    const swatch=e.target.closest('[data-ks-colour]');
    if(swatch){
      e.preventDefault();if(inlineBusy)return;closeInline();const card=swatch.closest('.ks-shopping-card');card.dataset.colour=swatch.dataset.ksColour;card.dataset.colourIndex=swatch.dataset.optionIndex;
      card.querySelectorAll('[data-ks-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===swatch)));
      try{const p=await product(swatch.dataset.productUrl);if(card.dataset.colour!==swatch.dataset.ksColour)return;const matches=p.variants.filter(v=>v.options[Number(swatch.dataset.optionIndex)]===swatch.dataset.ksColour);cardVariant(card,p,matches.find(v=>v.available)||matches[0]);}catch{location.assign(swatch.dataset.productUrl);}
      return;
    }
    const trigger=e.target.closest('[data-ks-open]');if(trigger&&typeof HTMLDialogElement!=='undefined'){e.preventDefault();quickAdd(trigger);}
  });
  let touch = null, swipedCard = null, swipeTime = 0;
  document.addEventListener('touchstart', e => {
    touch = null;
    if (e.touches.length !== 1 || e.target.closest('.ks-inline-sizes, button, [data-ks-open]')) return;
    const card = e.target.closest('.ks-shopping-card');
    if (card && e.target.closest('.card__inner') && card.querySelector('.media > img:nth-child(2)')) {
      touch = {card, x:e.touches[0].clientX, y:e.touches[0].clientY};
    }
  }, {passive:true});
  document.addEventListener('touchend', e => {
    if (!touch) return;
    const dx = e.changedTouches[0].clientX - touch.x;
    const dy = e.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      touch.card.classList.toggle('ks-touch-preview');
      swipedCard = touch.card; swipeTime = Date.now();
    }
    touch = null;
  }, {passive:true});
  document.addEventListener('touchcancel', () => { touch = null; }, {passive:true});
  // Suppress only the synthetic image click after a swipe; regular taps open details.
  document.addEventListener('click', e => {
    if (swipedCard?.contains(e.target) && e.target.closest('.card__inner') && !e.target.closest('.ks-inline-sizes') && Date.now() - swipeTime < 650) {
      e.preventDefault(); e.stopImmediatePropagation(); swipedCard = null;
    }
  }, true);
})();
